import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from 'react';
import { OptimizelySubitoContext } from '@sbt-web/houston-wrapper';
import { FeatureURI, type AdItem } from '@sbt-web/network/types';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
const GALLERY_PLACEMENT_TOGGLE = 'subito.web.adv.detail-gallery';
export const useLiraLazyOverlayGalleryForPrivate = t0 => {
  const $ = _c(15);
  const {
    ad,
    isDesktop
  } = t0;
  const [advDetailGalleryToggle, setAdvDetailGalleryToggle] = useState(false);
  const {
    optimizely
  } = useContext(OptimizelySubitoContext);
  let t1;
  if ($[0] !== optimizely) {
    t1 = () => {
      optimizely?.onReady().then(() => {
        setAdvDetailGalleryToggle(optimizely.isFeatureEnabled(GALLERY_PLACEMENT_TOGGLE));
      });
    };
    $[0] = optimizely;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isDesktop || $[3] !== optimizely) {
    t2 = [optimizely, isDesktop];
    $[2] = isDesktop;
    $[3] = optimizely;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== ad?.advertiser?.type || $[6] !== ad?.features || $[7] !== ad?.images?.length || $[8] !== advDetailGalleryToggle || $[9] !== isDesktop) {
    t3 = () => {
      let slots = [];
      if (!ad?.features?.[FeatureURI.ItemShippingCostTuttoSubito] && ad?.advertiser?.type === 0 && ad?.images?.length > 0 && advDetailGalleryToggle) {
        if (isDesktop) {
          slots.push(LiraContainerIds.adView.imageIntoGalleryForPrivate);
        } else {
          slots = [LiraContainerIds.adView.imageIntoGalleryForPrivateMsite];
        }
      }
      if (slots.length > 0) {
        window.liraSDKQueue?.push(() => {
          window.liraSdk?.fetchLazyLoadAd(slots);
        });
      }
    };
    $[5] = ad?.advertiser?.type;
    $[6] = ad?.features;
    $[7] = ad?.images?.length;
    $[8] = advDetailGalleryToggle;
    $[9] = isDesktop;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== ad || $[12] !== advDetailGalleryToggle || $[13] !== isDesktop) {
    t4 = [ad, advDetailGalleryToggle, isDesktop];
    $[11] = ad;
    $[12] = advDetailGalleryToggle;
    $[13] = isDesktop;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  useEffect(t3, t4);
};